export default __webpack_public_path__ + "static/rifatHamoudi-8c95cc3981c4c5986d9d0aedb72f7bb2.jpg";